import { User } from "lucide-react";
import React from "react";

interface AuditInformationProps {
  template: any;
}

export const AuditInformation: React.FC<AuditInformationProps> = ({
  template,
}) => {
  const auditFields = [
    {
      label: "CREATED BY",
      value: template?.createdBy,
    },
    {
      label: "CREATED ON",
      value: template?.createdOn,
    },
    {
      label: "LAST UPDATED BY",
      value: template?.lastUpdatedBy,
    },
    {
      label: "LAST UPDATED ON",
      value: template?.lastUpdatedOn,
    },
  ];

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-4">
        <User className="h-5 w-5 text-blue-600" />
        <h2 className="text-lg font-semibold text-blue-600">
          AUDIT INFORMATION
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {auditFields.map((field, index) => (
          <div key={index}>
            <p className="text-xs font-medium text-gray-500 mb-1">
              {field.label}
            </p>
            <p className="text-sm font-medium text-gray-900">
              {field.value || "N/A"}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
